import type { RequestOptions } from '@/libs/api/types';
import { submitBugReport, type SubmitBugReportRequest } from '@/services/submit-bug-report';
import { useMutation } from '@tanstack/react-query';

/**
 * Sends a bug report via POST `/api/v1/bug-report` (`issue`, optional `description` /
 * `attachments` URL strings). Backend errors surface through the shared server-error popup;
 * pass `{ skipServerErrorAlert: true }` to handle them at the call site.
 */
export function useSubmitBugReportMutation(options?: RequestOptions) {
  return useMutation({
    mutationFn: (body: SubmitBugReportRequest) => submitBugReport(body, options),
  });
}

export default useSubmitBugReportMutation;
